//
// FeatureFlagInfo.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "../models/TransportModel";
import "./FeatureFlagProduct";
import "./FeatureFlagStrategy";

var FeatureFlagInfo = createModule("transport::FeatureFlagInfo", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        createdBy: 7,
        strategies: [1],
        idLabel: 7,
        description: 7,
        creationTimeStamp: 7,
        id: 7,
        label: 7,
        issueTracking: [7],
        type: 7,
        version: 4,
        products: [1],
        revision: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default FeatureFlagInfo;
